module.exports = __webpack_public_path__ + "img/sidebar.cc8de0ee.jpg";